import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Status')
export class Status {
  @JsonProperty('code', Number, false) code: number = undefined;
  @JsonProperty('description', String, false) description: string = undefined;
}
